import(/* webpackMode: "eager", webpackExports: ["FeedView"] */ "/home/runner/work/apps/apps/packages/user-web-app/app/[companySlug]/(app)/FeedView.tsx");
